import { render, staticRenderFns } from "./PackageSample.vue?vue&type=template&id=b3ec9ddc&scoped=true&"
import script from "./PackageSample.vue?vue&type=script&lang=js&"
export * from "./PackageSample.vue?vue&type=script&lang=js&"
import style0 from "./PackageSample.vue?vue&type=style&index=0&id=b3ec9ddc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ec9ddc",
  null
  
)

export default component.exports